import { array } from "prop-types"

const StaticCategories = ({ selectedCategories = [], categories }) => {
  return (
    selectedCategories.length > 0 && (
      <>
        <h2 className="label">Categories</h2>
        <ul className="action-list my-0">
          {selectedCategories.map(sc => {
            const category = categories.find(c => c.id === sc.id)
            return (
              <li className="action-list__item p-1" key={category.id}>
                {category.attributes.name}
              </li>
            )
          })}
        </ul>
      </>
    )
  )
}

StaticCategories.propTypes = {
  selectedCategories: array,
  categories: array
}

export default StaticCategories
